import type { AuthUser } from '@/types';

function persistClientContext(user: AuthUser): void {
  const clientId = (user as any)?.clientId || (user as any)?.user?.clientId;
  const clientName = (user as any)?.clientName || (user as any)?.user?.clientName;

  if (clientId) {
    localStorage.setItem('agentic_client_id', String(clientId));
  } else {
    localStorage.removeItem('agentic_client_id');
  }

  if (clientName) {
    localStorage.setItem('agentic_client_name', String(clientName));
  } else {
    localStorage.removeItem('agentic_client_name');
  }
}

export function setUser(user: AuthUser, rememberMe = false): void {
  if (!user) return;

  try {
    localStorage.setItem('agentic_user_data', JSON.stringify(user));

    // Also store tenantId separately for easy access by apiClient
    if (user.tenantId) {
      localStorage.setItem('agentic_tenant_id', user.tenantId);
    }
    // Also check if tenantId is nested in user.user object
    if ((user as any)?.user?.tenantId) {
      localStorage.setItem('agentic_tenant_id', (user as any).user.tenantId);
    }
    persistClientContext(user);

    if (rememberMe) localStorage.setItem('agentic_remember_me', 'true');
    else localStorage.removeItem('agentic_remember_me');
  } catch (err) {
    console.error('Error saving user to localStorage:', err);
  }
}

export function getUser(): AuthUser | null {
  try {
    const data = localStorage.getItem('agentic_user_data');
    return data ? (JSON.parse(data) as AuthUser) : null;
  } catch {
    return null;
  }
}

export function clearUser(): void {
  localStorage.removeItem('agentic_user_data');
  localStorage.removeItem('agentic_remember_me');
  localStorage.removeItem('agentic_tenant_id');
  localStorage.removeItem('tenant_id');
  localStorage.removeItem('agentic_client_id');
  localStorage.removeItem('agentic_client_name');
}

export function setAuthTokens(token?: string, refreshToken?: string): void {
  try {
    if (token) localStorage.setItem('agentic_auth_token', token);
    if (refreshToken) localStorage.setItem('agentic_refresh_token', refreshToken);
  } catch (err) {
    console.error('Error saving tokens to localStorage:', err);
  }
}

export function getToken(): string | null {
  try {
    return localStorage.getItem('agentic_auth_token');
  } catch {
    return null;
  }
}

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem('agentic_refresh_token');
  } catch {
    return null;
  }
}

export function clearAuthTokens(): void {
  localStorage.removeItem('agentic_auth_token');
  localStorage.removeItem('agentic_refresh_token');
}
